import React, { useEffect, useState } from "react";
import axios from "axios";

Policyapprove2.propTypes = {};

function Policyapprove2(props) {
  
  

  const [Ppolicy, setPpolicy] = useState('');

  useEffect(() => {
    axios.get('https://adhigyanam-e92bf1bbbdb1.herokuapp.com/getPpolicy')
        .then(response => setPpolicy(response.data.Ppolicy))
        .catch(error => console.error('Error fetching Ppolicy:', error));
}, []);

  return (
    <>
    
     <section className="testimonials-category-section" style={{ paddingTop: "30px", paddingBottom:"30px" }}>
           <div className="tf-container">
             <div className="row">
           
     
               <div className="col-md-10"  style={{margin:"auto", padding:"auto"}}>
                 <div className="row">
                  <div
       style={{ marginBottom: "5px", marginTop: "10px" }}
       dangerouslySetInnerHTML={{ __html: Ppolicy }}
     ></div>
                 </div>
               </div>
             </div>
           </div>
         </section>
      
      
    </>
  );
}

export default Policyapprove2;
